module.exports = __webpack_public_path__ + "media/images/pic/teachers/ryotaro-sakamoto-7f9a6a88b6eb53da23ef75ee2abe256e.webp";